<template>
  <path
    d="M9 16.2002L5.5 12.7002C5.11 12.3102 4.49 12.3102 4.1 12.7002C3.71 13.0902 3.71 13.7102 4.1 14.1002L8.29 18.2902C8.68 18.6802 9.31 18.6802 9.7 18.2902L20.3 7.70019C20.69 7.31019 20.69 6.69019 20.3 6.30019C19.91 5.91019 19.29 5.91019 18.9 6.30019L9 16.2002Z"
  />
</template>
